import { useEffect } from 'react';
import {
  useAppSelector,
  getToken,
  getIsAuthenticated,
  getUserData,
  UserType,
} from '@zonofi/zono-money-store';
import { redirectionModalRef } from '../../modals';

export const useSellerHubInitialization = () => {
  const isAuthenticated = useAppSelector(getIsAuthenticated);
  const token = useAppSelector(getToken);
  const userData = useAppSelector(getUserData);
  const { inviteUserType = '' } = userData;
  const isUserDataHydrated = Boolean(userData.id || userData.token);

  useEffect(() => {
    if (
      token &&
      isAuthenticated &&
      isUserDataHydrated &&
      inviteUserType === UserType.SALES
    ) {
      redirectionModalRef.current?.openRedirectionModal();
    }
  }, [token, isAuthenticated, inviteUserType, isUserDataHydrated]);
};
